import { gradients } from '@airwallex/global';
import transform from 'lodash/transform';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// AWX gradients as default values
var twoColorsGradients = {
  primary: gradients.yellow,
  secondary: gradients.orange,
  tertiary: gradients.red,
  quaternary: gradients.pink,
  quinary: gradients.purple
};
var threeColorsGradients = {
  spectrumPrimary: gradients.spectrumOrange,
  spectrumSecondary: gradients.spectrumPurple
};
var gradientTokens = _extends({}, twoColorsGradients, threeColorsGradients);
var getGradientFromColorSet = colors => {
  // two colors gradients
  if (colors.length === 2) {
    var [from, to] = colors;
    return "linear-gradient(135deg, " + from + " 0%, " + to + " 100%)";
  }
  // three colors gradients (spectrum)
  if (colors.length === 3) {
    var [from1, mid, to1] = colors;
    return "linear-gradient(135deg, " + from1 + " 0%, " + mid + " 50%, " + to1 + " 100%)";
  }
};
var getGradientsOverride = gradientOverride => {
  if (!gradientOverride) return {};
  return transform(gradientOverride, (result, value, key) => {
    if (value) {
      var gradientValue = getGradientFromColorSet(value);
      if (gradientValue) {
        result[key] = gradientValue;
      } else {
        // delete invalid
        delete result[key];
      }
    }
  }, {});
};
export { getGradientsOverride, gradientTokens, threeColorsGradients, twoColorsGradients };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
